module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';
	
	fox.registerWidget('mcGoogleAnalytics', {
		/**
		 * Track pageview.
		 * @param {string} page Name of tracked page
		 * @param {boolean} logPage If true, send navigator information to api logger.log
		 * @return {void}
		 */
		trackPageview: function(page, logPage) {
			this.callParent('trackPageview', [page]);

			if (fox.isEmpty(fox.site.member) && (fox.getEnv('affiliateArea') || fox.getEnv('globalSubscription'))) {
				var api = this.getApi('affTrack', {method: 'affiliate.track'});
				var data = {
					page: page
				};

				var foxref = null;

				if (foxref = fox.cookie.get('foxref')) {
					data.refCode = foxref;
				}

				api.send(data, false);
			}

			var permissionManager = fox.wom.selectFirst('~.PermissionManager');

			var isMember = permissionManager
				? !fox.isEmpty(permissionManager.getMemberInfo())
				: !fox.isEmpty(fox.site.member)
			;

			if (isMember && logPage) {
				var page = fox.Navigator.getAll()[0];

				if (!fox.inArray(['scene', 'gallery', 'product'], page)) {
					return;
				}

				var api = this.getApi('loggerLog', {method: 'logger.log'});

				api.send({
					index: 'McUserActivity',
					path: fox.Navigator.getAll()
				}, false);	
			}
		},

		/**
		 * Set default google dimensions for tracker with name "trackerName"
		 * @param {string} trackerName
		 * return {void}
		 */
		_setTrackerDimensions: function(trackerName) {
			this.callParent('_setTrackerDimensions', arguments);

			var foxref = fox.cookie.get('foxref');
			var acode = fox.cookie.get('acode');
			var parsedUrl, getParams;

			if (!acode) {
				parsedUrl = fox.Navigator.parseUrl(document.location);

				if (parsedUrl.search) {
					getParams = fox.Navigator.parseSearch(parsedUrl.search);

					if (getParams['acode']) {
						acode = getParams['acode'];
					}
				}
			}

			ga(trackerName + '.set', 'dimension2', fox.isEmpty(foxref) ? "" : foxref);
			ga(trackerName + '.set', 'dimension3', fox.isEmpty(acode) ? "" : acode);
		}

	}, 'googleAnalytics');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/ga/widget/mcgoogleanalytics.js
// module id = 31
// module chunks = 5